export const PATH_PREFIX = document.location.pathname.includes('/sw/')
  ? document.location.pathname.split('/sw/')[0]
  : '';

export const PATH_PREFIX_ABS = `${PATH_PREFIX}/`;

const BRANCH_API = `${PATH_PREFIX}/sw/v2/api/branch`;

export const ELEMENT_DATABASE_API = `${PATH_PREFIX}/sw/api/elements_database/`;
export const WORK_SEQUENCE_API = `${PATH_PREFIX}/sw/api/builder/worksequence/`;
export const ACTIVITY_ROLE_API = `${PATH_PREFIX}/sw/api/builder/activityrole/`;
export const REORDER_ELEMENT_INSTANCE_API = `${ELEMENT_DATABASE_API}elementinstancereorder/`;
export const ISSUE_LIST_API = `${PATH_PREFIX}/sw/v2/api/flags/`;
export const IMPROVEMENT_API = `${PATH_PREFIX}/sw/api/improvement/`;
export const ELEMENT_INSTANCE_CONTEXTUAL_API = `${PATH_PREFIX}/sw/v2/api/element_instance/`;
export const BRANCH_ASSIGNED_WORK_CENTRES_API = `${BRANCH_API}/{id}/assigned-work-centres/`;